export function adminError(cause, fallback = '操作失敗，請檢查欄位或網路後重試。') {
  const status = cause.response?.status;
  return {
    400: '輸入內容不符合規則，請檢查欄位後重試。',
    401: '登入已失效，請重新登入。',
    403: '此操作需要管理員權限。',
    404: '找不到此資料，請返回列表確認。',
    409: '中文來源或英文版本已變動，您的未存內容已保留，請重新核對版本。',
    422: '內容驗證失敗，請檢查必填欄位、HTML 及搜尋資訊。'
  }[status] || fallback;
}
